import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../css/SearchBar.css";
import { Button } from "@mui/material";
import MoreInfo from "../components/MoreInfo";
import { getFarmacia } from "../api/userApi";

const url_base = "https://api.farmasite.com.ar";

const SearchBar = ({ onAddToCart = () => {}, backgroundColor }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [showInfo, setShowInfo] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); // nuevo estado
  const [ownColor, setOwnColor] = useState(null);
  const { cuit } = useParams();

  // Si no nos pasan el color por prop (ej: si SearchBar se usa solo, sin ProfilePage
  // alrededor), lo buscamos nosotros mismos a partir del cuit de la URL.
  useEffect(() => {
    if (backgroundColor || !cuit) return;
    getFarmacia(cuit)
      .then((res) => setOwnColor(res.data?.farmacia?.backgroundcolor || null))
      .catch(() => {});
  }, [cuit, backgroundColor]);

  const resolvedColor = backgroundColor || ownColor;

  const handleSearch = async () => {
    try {
      const response = await fetch(url_base + "/vademecum" + (cuit ? `/${cuit}` : ""), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ searchdata: searchTerm }),
      });

      const data = await response.json();
      setResults(data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleRefresh = () => {
    setSearchTerm("");
    setResults([]);
  };

  return (
    <div
      className="search-container"
      style={resolvedColor ? { backgroundColor: resolvedColor } : undefined}
    >
      <div className="search-bar">
        <label>
          {" "}
          Nombre, prescripción, principio activo, troquel o laboratorio:{" "}
        </label>
        <input
          type="text"
          placeholder="Ej: Ibuprofeno"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <div className="button-group">
          <button onClick={handleSearch} className="search-button">
            Consultar
          </button>
          <button onClick={handleRefresh} className="refresh-button">
            Refrescar
          </button>
        </div>
      </div>
      <div className="results-grid">
        {results.length > 0 && (
          <div className="results-header">
            <div className="col-nombre">Nombre</div>
            <div className="col-precio">Precio</div>
            <div className="col-pami">Precio PAMI</div>
            <div className="col-info"></div>
          </div>
        )}

        {results.map((item, index) => (
          <div key={index} className="result-row">
            <div className="col-nombre">
              <div className="nombre">{item.NOMBRE}</div>
              <div className="presentacion">{item.PRESENTACION}</div>
            </div>
            <div className="col-precio">${(+item.PRECIO).toFixed(2)}</div>
            <div className="col-pami">
              {item.PRECIOPAMI > 0 ? `$${(+item.PRECIOPAMI).toFixed(2)}` : ""}
            </div>
            <div className="col-info">
              <Button
                className="agregar"
                size="small"
                variant="outlined"
                onClick={() => onAddToCart(item)}
              >
                Agregar
              </Button>
              <Button
                className="info"
                size="small"
                onClick={() => {
                  setSelectedItem(item); // guarda el ítem clickeado
                  setShowInfo(true); // muestra el modal
                }}
              >
                Info
              </Button>
              <MoreInfo visible={showInfo} onHide={() => setShowInfo(false)} item={selectedItem} />
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchBar;